// density.ts — 밀도 모드 상수 정의.
// DensityMode: 'compact' | 'default' | 'comfortable'
// DENSITY_STORAGE_KEY: localStorage 키
// DENSITY_LABELS: UI 표시용 한국어 라벨

export type DensityMode = 'compact' | 'default' | 'comfortable';

export const DENSITY_STORAGE_KEY = 'locker:density';

export const DENSITY_DEFAULT: DensityMode = 'default';
export const DENSITY_MOBILE_DEFAULT: DensityMode = 'comfortable';

// 모바일 분기점 (px) — 이 너비 미만이면 모바일로 간주
export const DENSITY_MOBILE_BREAKPOINT = 768;

export const DENSITY_OPTIONS: {
  value: DensityMode;
  label: string;
  description: string;
}[] = [
  { value: 'compact',     label: '컴팩트', description: '더 많은 항목을 한 화면에' },
  { value: 'default',     label: '기본',   description: '균형 잡힌 밀도' },
  { value: 'comfortable', label: '편안',   description: '넓은 간격, 큰 글자' },
];
